module.exports = __webpack_public_path__ + "img/result-detail-invest-outleft02.e449c7e2.svg";